import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Confirm from 'components/common/confirm-modal'

import { sitesActions, Site } from 'modules/sites'
import InputCollection from './inputs-collection'
import withCurrentSite from 'modules/sites/containers/with-current-site'


export class SiteForm extends Component {
  static propTypes = {
    createSite: PropTypes.func.isRequired,
    currentSite: PropTypes.instanceOf(Site),
    deleteSite: PropTypes.func,
    updateSite: PropTypes.func.isRequired,
  }

  state = { progress: false }

  onSubmit = e => {
    e.preventDefault()
    const { currentSite, createSite, updateSite } = this.props
    const form = { auth: {} }

    for (let entry of new FormData(e.target).entries()) {
      const [key, value] = entry

      if (key.indexOf('[]') !== -1) {
        let arrayKey = key.replace('[]', '')
        Array.isArray(form[arrayKey]) ? form[arrayKey] = form[arrayKey].concat(value) : form[arrayKey] = [].concat(value)
      }
      else if (['user', 'pass'].indexOf(key) !== -1) {
        form.auth[key] = value
      }
      else {
        form[key] = value
      }
    }

    if (currentSite) {
      updateSite(currentSite, form)
    }
    else {
      createSite(form)
    }
  }

  deleteSite = () => {
    const { currentSite: form, deleteSite } = this.props

    if (form) {
      deleteSite(form)
      this.setState({ progress: true })
    }
  }

  renderFormButtons = () => {
    const { currentSite } = this.props

    return (
      <div className="offset-sm-3 col-sm-9">
        <button
          className="btn btn-primary mr-3"
          type="submit">
          { currentSite ? 'Save' : 'Add' }
        </button>
        {
          currentSite && (
            <Confirm
              title="Delete"
              body={this.renderConfirmDeleteBody()}
              btnLabel="Delete"
              onConfirm={this.deleteSite}
            />
          )
        }
      </div>
    )
  }

  renderConfirmDeleteBody = () => {
    return (
      <span>
        You are about to delete <span className="text-primary">{this.props.currentSite.name}</span> and its history. It cannot be restored.<br />
        Are you sure?
      </span>
    )
  }

  render() {
    const form = this.props.currentSite || {}

    if (this.state.progress) {
      return (
        <div className="card card-block mb-4">
          <div>
            <i className="zmdi zmdi-spinner zmdi-hc-spin" /> Please wait....
          </div>
        </div>
      )
    }

    return (
      <form className="card card-block site-form mb-4" autoComplete="off" onSubmit={this.onSubmit}>
        <h4 className="text-center mb-4">Site Settings</h4>
        <div className="form-group row">
          <label htmlFor="site-name" className="col-sm-3 col-form-label">Name</label>
          <div className="col-sm-9">
            <input
              id="site-name" className="form-control" type="text" name="name"
              defaultValue={form.name} required
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="site-url" className="col-sm-3 col-form-label">URL</label>
          <div className="col-sm-9">
            <input
              id="site-url" className="form-control" type="url" name="url"
              defaultValue={form.url} placeholder="https://www.example.com" required
            />
          </div>
        </div>
        <div className="form-group row">
          <label htmlFor="site-basic-auth" className="col-sm-3 col-form-label">Basic Authentication</label>
          <div className="col-sm-9">
            <div className="row">
              <div className="col-md-6">
                <input
                  className="form-control mb-sm-0 mb-3" type="text" name="user"
                  placeholder="Username"
                  defaultValue={(form.auth || {}).user} autoComplete="off"
                />
              </div>
              <div className="col-md-6">
                <input
                  className="form-control" type="password" name="pass"
                  autoComplete="new-password"
                  placeholder="Password" defaultValue={(form.auth || {}).pass}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-3 col-form-label">Sitemap(s)</label>
          <div className="col-sm-9">
            <InputCollection name="sitemaps[]" defaultValue={form.sitemaps || ['sitemap.xml']} />
          </div>
        </div>
        <div className="form-group row">
          { this.renderFormButtons() }
        </div>
      </form>
    )
  }
}

const WrappedSiteForm = connect(null, sitesActions)(SiteForm)
export const SiteEditForm = withCurrentSite(WrappedSiteForm)
export default WrappedSiteForm



// WEBPACK FOOTER //
// ./src/components/sites/site-form.js